import * as React from "react";
import { Grid } from "semantic-ui-react";
import ForgotPasswordForm from "../../components/ForgotPasswordForm/ForgotPasswordForm";

class ForgotPassword extends React.Component {
    render() {
        return (
            <Grid centered={true} verticalAlign="middle" className="login-page">
                <Grid.Column>
                    <ForgotPasswordForm/>
                </Grid.Column>
            </Grid>
        );
    }
}

export default ForgotPassword;
